import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import RecentNews from '../../../components/RecentNews'
import WidthContainer from '../../../components/WidthContainer'
import {QueryedButton} from '../../../components/Button'
import {buttonType} from '../../../utils/commonPropTypes'


const RootContainer = styled(WidthContainer)`
	margin-top: 3rem;
	margin-bottom: 2rem;
`

const Title = styled.h1`
	margin-bottom: 4.3rem;
	font-size: ${props => props.theme.fontSizes.big30};
`

const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	margin-top: 4.6rem;
`

const NewsSection = ({className, data}) => <RootContainer className={className}>
	<Title>{data.title}</Title>
	<RecentNews/>
	<ButtonContainer>
		<QueryedButton data={data.button}/>
	</ButtonContainer>
</RootContainer>

NewsSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		title: PropTypes.string.isRequired,
		button: buttonType.isRequired,
	}).isRequired,
}

NewsSection.defaultProps = {
	className: '',
}

export default NewsSection
